// extracted by mini-css-extract-plugin
module.exports = {"modelSection":"Model_modelSection__y0D6x"};